import ringIconGreen1 from 'assets/images/loader-ring-1-desktop.png';
import ringIcon1 from 'assets/images/loader-ring-1.png';
import ringIconGreen2 from 'assets/images/loader-ring-2-desktop.png';
import ringIcon2 from 'assets/images/loader-ring-2.png';
import ringIconIE1 from 'assets/images/loaderIE1.png';
import ringIconIE2 from 'assets/images/loaderIE2.png';
import styled from 'styled-components';

const isDisplay = ({ isLoading = false }: { isLoading: boolean }) => (isLoading ? 'flex' : 'none');

const Container = styled.div<{ isLoading: boolean }>`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: ${isDisplay};
  justify-content: center;
  align-items: center;
`;

const ContainerIE = styled(Container)`
  position: static;
  margin-bottom: 24px;
`;

const ContainerDeleteCard = styled.div<{ isLoading: boolean }>`
  height: 100%;
  width: 100%;
  position: relative;
  display: ${isDisplay};
  justify-content: center;
  align-items: center;
`;

const Wrapper = styled.div`
  height: 2.5rem;
  width: 2.5rem;
`;

const WrapperIE = styled(Wrapper)`
  height: 16rem;
  width: 16rem;
`;

const Ring = styled.div`
  @keyframes rotate360 {
    to {
      transform: rotate(360deg);
    }
  }

  position: absolute;
  width: 2.5rem;
  height: 2.5rem;
  background-repeat: no-repeat;
  animation-name: rotate360;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
`;

const RingIE = styled(Ring)`
  height: 16rem;
  width: 16rem;
`;

const Ring1 = styled(Ring)`
  background-image: url(${ringIcon1});
  animation-duration: 1s;
  background-image: url(${ringIconGreen1});
`;

const Ring2 = styled(Ring)`
  background-image: url(${ringIcon2});
  animation-duration: 700ms;
  background-image: url(${ringIconGreen2});
`;

const RingIE1 = styled(RingIE)`
  background-image: url(${ringIconIE1});
  animation-duration: 1.5s;
`;

const RingIE2 = styled(RingIE)`
  background-image: url(${ringIconIE2});
  animation-duration: 1050ms;
`;

export { Container, Ring1, Ring2, RingIE1, RingIE2, Wrapper, WrapperIE, ContainerIE, ContainerDeleteCard };
